import { SpinnerWrapper } from '@repo/ui/components/Icon';
import { P1 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const ComponentWrapper = styled.div`
  padding: 32px 16px;

  ${QUERIES.largeTabletAndUp} {
    padding: 40px 48px;
  }

  ${QUERIES.smallDesktopAndUp} {
    padding: 48px 120px;
  }
`;

export const Wrapper = styled(FlexColumn)`
  gap: 32px;

  ${QUERIES.largeTabletAndUp} {
    gap: 24px;
  }

  ${QUERIES.smallDesktopAndUp} {
    max-width: 1120px;
    margin: 0 auto;
  }
`;

export const Description = styled(P1)`
  ${QUERIES.laptopAndUp} {
    max-width: 890px;
  }
`;

export const Grid = styled.div`
  display: grid;
  width: 100%;

  gap: 32px 12px;
  grid-template-columns: repeat(2, 1fr);

  ${QUERIES.largeTabletAndUp} {
    gap: 40px 24px;
    grid-template-columns: repeat(3, 1fr);
  }

  ${QUERIES.laptopAndUp} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${QUERIES.smallDesktopAndUp} {
    justify-content: space-between;
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const CenteredSpinnerWrapper = styled(SpinnerWrapper)`
  width: 50px;
  margin: auto;
  padding: 40px 0;
`;
